module.exports = __webpack_public_path__ + "img/example-report.f18df470.png";